import { render, staticRenderFns } from "./designManage.vue?vue&type=template&id=90ab8a5c&"
import script from "./designManage.vue?vue&type=script&lang=js&"
export * from "./designManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports